import React, { Component } from "react";
import { connect } from "react-redux";
import {
    createPackage,
    updatePackage,
    deletePackage,
    fetchAllPackages,
    fetchResourceTemplates
} from "../../Store/Slices/Admin/ManagerPackage";

import {
    fetchAllUsers
} from "../../Store/Slices/Admin/ManagerTenant";

class PackageManager extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedPackageId: "",
            selectedPackage: null,
            isCreatingNew: false,
            formErrors: {},
            savingPackage: false,
            successMessage: null,
            errorMessage: null,
            filters: {
                search: "",
                type: "",
                ownerId: "",
                isPublic: ""
            },
            formData: {
                name: "",
                description: "",
                type: "basic",
                ownerId: "",
                isPublic: false,
                resources: [],
                min_disk_size: 10,
            },
            totalResourceCost: 0
        };
    }

    componentDidMount() {
        this.props.fetchAllPackages();
        this.props.fetchAllUsers();
        this.props.fetchResourceTemplates();
    }

    getEmptyFormData = () => ({
        name: "",
        description: "",
        type: "basic",
        ownerId: "",
        isPublic: false,
        resources: []
    });

    getSnapshotPrice = (snapshotId) => {
        const { snapshots, sizes } = this.props;

        const snapshot = snapshots.find(s => s.id === snapshotId);
        if (!snapshot) return 0.1;

        const min_disk_size = snapshot.min_disk_size;

        const region = snapshot?.regions?.[0] || null;
        if (!region)
            return 0.1;

        const size = sizes.filter(s =>
            s.available && s.regions?.includes(region) && s.disk >= min_disk_size
        );

        const p = size?.[0]?.price_hourly || 0.1;
        return Math.ceil(p * 100) / 100;
    }

    handleFilterChange = (field, value) => {
        this.setState(prev => ({
            filters: {
                ...prev.filters,
                [field]: value
            }
        }));
    };

    clearFilters = () => {
        this.setState({
            filters: {
                search: "",
                type: "",
                ownerId: "",
                isPublic: ""
            }
        });
    };

    getFilteredPackages = () => {
        const { packages } = this.props;
        const { filters } = this.state;

        return (packages || []).filter(pkg => {
            return (
                (!filters.search || pkg.name.toLowerCase().includes(filters.search.toLowerCase())) &&
                (!filters.type || pkg.type === filters.type) &&
                (!filters.ownerId || pkg.ownerId === filters.ownerId) &&
                (filters.isPublic === "" || String(pkg.isPublic) === filters.isPublic)
            );
        });
    };

    handlePackageSelect = (pkg) => {
        const { packageResources } = this.props;
        const resources = packageResources.find(r => r.id === pkg.id)?.resources || [];
        this.setState({
            selectedPackageId: pkg.id,
            selectedPackage: pkg,
            isCreatingNew: false,
            formData: {
                name: pkg.name || "",
                description: pkg.description || "",
                type: pkg.type || "basic",
                ownerId: pkg.ownerId || "",
                isPublic: pkg.isPublic || false,
                resources: resources.map((r, i) => {
                    return {
                    resourceId: r.resourceImageId || "",
                        name: r.name,
                        hasDomain: r.hasDomain || false,
                        initScript: r.initScript || "",
                        configId: r.configId || "",
                    }
                }),
            },
        });
    };

    handleCreateNew = () => {
        this.setState({
            isCreatingNew: true,
            selectedPackageId: "",
            selectedPackage: null,
            formErrors: {},
            formData: this.getEmptyFormData()
        });
    };

    handleFieldChange = (field, value) => {
        this.setState(prev => ({
            formData: {
                ...prev.formData,
                [field]: value,
            },
        }));
    };

    handleAddResource = () => {
        this.setState(prev => ({
            formData: {
                ...prev.formData,
                resources: [
                    ...prev.formData.resources,
                    {
                        resourceId: "",
                        provider: "digitalocean",
                        region: "",
                        size: "",
                        price: 0
                    }
                ]
            },
        }));
    };

    handleRemoveResource = (index) => {
        this.setState(prev => ({
            formData: {
                ...prev.formData,
                resources: prev.formData.resources.filter((_, i) => i !== index),
            },
        }));
    };

    handleUpdateResource = (index, field, value) => {
        this.setState(prev => {
            const updated = [...prev.formData.resources];

            if (field === "resourceId") {
                updated[index] = {
                    ...updated[index],
                    resourceId: value,
                    region: "",
                    size: "",
                    price: 0,
                };
            } else if (field === "region") {
                updated[index] = {
                    ...updated[index],
                    region: value,
                    size: "",
                    price: 0,
                };
            } else {
                updated[index] = {
                    ...updated[index],
                    [field]: value
                };
            }

            return {
                formData: {
                    ...prev.formData,
                    resources: updated
                }
            };
        });
    };

    validateForm = () => {
        const { formData } = this.state;

        const errors = {
            resources: []
        };

        if (!formData.name) errors.name = "Required";

        if (!formData.ownerId || formData.ownerId === "")
            errors.ownerId = "Required";

        formData.resources.forEach((r, i) => {
            errors.resources[i] = {
                name: !r.name ? "Required" : "",
                resourceId: !r.resourceId ? "Required" : ""
            };
        });

        this.setState({ formErrors: errors });

        const hasErrors =
            errors.name ||
            errors.ownerId ||
            errors.resources.some(r => r.name || r.resourceId);

        return !hasErrors;
    };

    handleSave = async () => {
        
        this.setState({ savingPackage: true });
            if (!this.validateForm()) {
                this.setState({
                    errorMessage: "Invalid Form",
                    savingPackage: false,
                });
                return;
            }
            const payload = {
                Name: this.state.formData.name,
                Description: this.state.formData.description,
                Type: this.state.formData.type,
                OwnerId: this.state.formData.ownerId,
                IsPublic: this.state.formData.isPublic,
                Resources: this.state.formData.resources
            };

            if (this.state.isCreatingNew) {
                await this.props.createPackage(payload);
            } else {
                await this.props.updatePackage({
                    packageId: this.state.selectedPackageId,
                    payload
                });
            }
            this.setState({
                savingPackage: false,
                isCreatingNew: false,
                selectedPackageId: "",
                formData: this.getEmptyFormData()
            });

            this.props.fetchAllPackages();
    };

    handleCancel = () => {
        this.setState({
            isCreatingNew: false,
            selectedPackageId: "",
            selectedPackage: null,
            formErrors: {},
            formData: this.getEmptyFormData()
        });
    };

    handleDelete = async () => {
        await this.props.deletePackage(this.state.selectedPackageId);
        await this.props.fetchAllPackages();
        this.handleCancel();
    };

    

    render() {
        const { snapshots, users, configs } = this.props;
        const { selectedPackageId, isCreatingNew, formData, formErrors, savingPackage, filters } = this.state;

        const showEditor = selectedPackageId || isCreatingNew;
        const packages = this.getFilteredPackages();

        return (
            <div className="min-h-screen bg-gray-50 p-6">
                {!showEditor && (
                    <div className="bg-white p-4 rounded-lg shadow mb-6 flex flex-wrap gap-3">
                        <input
                            placeholder="Search..."
                            value={filters.search}
                            onChange={(e) => this.handleFilterChange("search", e.target.value)}
                            className="border p-2 rounded"
                        />

                        <select
                            value={filters.type}
                            onChange={(e) => this.handleFilterChange("type", e.target.value)}
                            className="border p-2 rounded"
                        >
                            <option value="">All Types</option>
                            <option value="basic">Basic</option>
                            <option value="advanced">Advanced</option>
                            <option value="enterprise">Enterprise</option>
                        </select>

                        <select
                            value={filters.ownerId}
                            onChange={(e) => this.handleFilterChange("ownerId", e.target.value)}
                            className="border p-2 rounded"
                        >
                            <option value="">All Users</option>
                            {users?.map(u => (
                                <option key={u.id} value={u.id}>
                                    {u.name || u.email}
                                </option>
                            ))}
                        </select>

                        <select
                            value={filters.isPublic}
                            onChange={(e) => this.handleFilterChange("isPublic", e.target.value)}
                            className="border p-2 rounded"
                        >
                            <option value="">All</option>
                            <option value="true">Public</option>
                            <option value="false">Private</option>
                        </select>

                        <button
                            onClick={this.clearFilters}
                            className="bg-gray-200 px-3 py-2 rounded"
                        >
                            Clear
                        </button>

                        <button
                            onClick={this.handleCreateNew}
                            className="bg-blue-600 text-white px-4 py-2 rounded ml-auto"
                        >
                            + Create
                        </button>
                    </div>
                )}

                {!showEditor && (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        {packages.map(pkg => (
                            <div
                                key={pkg.id}
                                onClick={() => this.handlePackageSelect(pkg)}
                                className="bg-white border p-4 rounded cursor-pointer hover:shadow"
                            >
                                <div className="font-bold">{pkg.name}</div>
                                <div className="text-sm text-gray-500">{pkg.type}</div>
                                <div className="text-xs">{pkg.isPublic ? "Public" : "Private"}</div>
                                <div className="text-xs">{pkg.price} / hr</div>
                            </div>
                        ))}
                    </div>
                )}

                {showEditor && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="grid grid-cols-1 gap-6">
                            <div className="bg-white p-6 rounded-lg shadow">
                                <button
                                    type="button"
                                    className="btn btn-danger float-end"
                                    onClick={() => this.handleDelete()}
                                >
                                    Delete Package
                                </button>
                                <h2 className="font-bold mb-4">Basic Info</h2>

                                <input
                                    value={formData.name}
                                    onChange={(e) => this.handleFieldChange("name", e.target.value)}
                                    placeholder="Name"
                                    className="w-full border p-2 mb-3 rounded"
                                />
                                {formErrors?.name && (
                                    <p className="text-red-500 text-sm mb-3">
                                        {formErrors.name}
                                    </p>
                                )}

                                <textarea
                                    value={formData.description}
                                    onChange={(e) => this.handleFieldChange("description", e.target.value)}
                                    className="w-full border p-2 mb-3 rounded"
                                />

                                <select
                                    value={formData.type}
                                    onChange={(e) => this.handleFieldChange("type", e.target.value)}
                                    className="w-full border p-2 mb-3 rounded"
                                >
                                    <option value="basic">Basic</option>
                                    <option value="advanced">Advanced</option>
                                    <option value="enterprise">Enterprise</option>
                                </select>

                                <select
                                    value={formData.ownerId}
                                    onChange={(e) => this.handleFieldChange("ownerId", e.target.value)}
                                    className="w-full border p-2 mb-3 rounded"
                                >
                                    <option value="">Select owner</option>
                                    {users?.map(u => (
                                        <option key={u.id} value={u.id}>
                                            {u.name || u.email}
                                        </option>
                                    ))}
                                </select>
                                {formErrors?.ownerId && (
                                    <p className="text-red-500 text-sm mb-3">
                                        {formErrors.ownerId}
                                    </p>
                                )}

                                <label className="flex items-center gap-2">
                                    <input
                                        type="checkbox"
                                        checked={formData.isPublic}
                                        onChange={(e) => this.handleFieldChange("isPublic", e.target.checked)}
                                    />
                                    Public
                                </label>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 gap-6">
                            <div className="bg-white p-6 rounded-lg shadow">
                                <div className="flex justify-between mb-4">
                                    <h2 className="font-bold">Resources</h2>
                                    <button onClick={this.handleAddResource} className="btn btn-success float-end">+ Add</button>
                                </div>

                                {formData.resources.map((r, i) => {
                                    return (<div
                                        key={i}
                                        className="border p-3 mb-3 rounded flex flex-col gap-2"
                                    >
                                        <div className="flex flex-wrap">
                                            <span>Hourly Cost: {this.getSnapshotPrice(formData.resources[i].resourceId)}</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <label className="flex items-center gap-2">
                                                <input
                                                    type="checkbox"
                                                    checked={formData.resources[i].hasDomain}
                                                    onChange={(e) => this.handleUpdateResource(i, "hasDomain", e.target.checked)}
                                                />
                                                Generate access URL
                                            </label>
                                            <button
                                                onClick={() => this.handleRemoveResource(i)}
                                                className="btn btn-danger"
                                            >
                                                Remove
                                            </button>
                                        </div>
                                        <div className="flex flex-wrap gap-2">
                                            <label className="flex flex-1 items-center">Name</label>
                                            <input
                                                value={formData.resources[i].name}
                                                onChange={(e) => this.handleUpdateResource(i, "name", e.target.value)}
                                                placeholder="Resource Name"
                                                className="flex-1 border p-2 rounded"
                                            />
                                            {formErrors.resources?.[i]?.name && (
                                                <p className="text-red-500 text-sm mb-3">
                                                    {formErrors.resources[i].name}
                                                </p>
                                            )}
                                        </div>

                                        <div className="flex flex-wrap gap-2">
                                            <label className="flex flex-1 items-center">Base Template</label>
                                            <select
                                                value={r.resourceId}
                                                onChange={(e) => {
                                                    const selectedOption = e.target.options[e.target.selectedIndex];
                                                    this.handleUpdateResource(i, "min_disk_size", selectedOption.getAttribute("data-size"))
                                                    this.handleUpdateResource(i, "resourceId", e.target.value)
                                                }
                                                }
                                                className="border p-2 rounded flex-1"
                                            >
                                                <option value="">Select Snapshot</option>
                                                {snapshots.map(img => {
                                                    formData.resources[i].min_disk_size = img.min_disk_size;
                                                    return (<option key={img.id} value={img.id} data-size={img.min_disk_size}>
                                                        {img.name}
                                                    </option>
                                                    )
                                                })}
                                            </select>
                                            {formErrors.resources?.[i]?.resourceId && (
                                                <p className="text-red-500 text-sm mb-3">
                                                    {formErrors.resources[i].resourceId}
                                                </p>
                                                )}
                                        </div>
                                        <div className="flex flex-wrap gap-2">
                                            <label className="flex flex-1 items-center">Configuration</label>
                                            <select className="border p-2 rounded flex-1"
                                                value={r.configId}
                                                onChange={(e) => {
                                                    this.handleUpdateResource(i, "configId", e.target.value)
                                                }}
                                            >
                                                <option value="">No Configuration</option>
                                                {configs?.map(c => {
                                                    return <option key={c.id} value={c.id}>{c.name}</option>
                                                })}
                                            </select>
                                        </div>
                                        {
                                            configs.filter(c => c.id === r.configId)[0]
                                                ?.fields?.map(f => {
                                                    return <>
                                                        <div className="flex flex-wrap gap-2">
                                                            <label className="flex flex-1 items-center">{f.displayName}</label>
                                                            <input
                                                                value={f.keyName}
                                                                className="flex-1 border p-2 rounded"
                                                                disabled="disabled"
                                                                readOnly
                                                            />
                                                        </div>
                                                        <div className="flex flex-wrap">
                                                            <label className="flex flex-1 items-center">Description</label>
                                                            <textarea className="flex-1 border p-2 rounded" disabled="disabled" readOnly>{f.description}</textarea>
                                                        </div>
                                                        <hr/>
                                                    </>
                                                })
                                        }
                                        


                                        <h2>Cloud Script</h2>
                                        <textarea
                                            value={formData.resources[i].initScript}
                                            onChange={(e) => this.handleUpdateResource(i, "initScript", e.target.value)}
                                            className="w-full border p-2 mb-3 rounded h-100"
                                            rows="10"
                                        />
                                        {/*{formData.resources[i].resourceId !== "" && <select*/}
                                        {/*    value={r.region}*/}
                                        {/*    onChange={(e) => {*/}
                                        {/*        this.handleUpdateResource(i, "region", e.target.value)*/}
                                        {/*    }*/}
                                        {/*    }*/}
                                        {/*    className="border p-2 rounded flex-1"*/}
                                        {/*>*/}
                                        {/*    <option value="">Select Region</option>*/}
                                        {/*    {this.getRegionsForSnapshot(r.resourceId).map(region => (*/}
                                        {/*        <option key={region.slug} value={region.slug}>*/}
                                        {/*            {region.name}*/}
                                        {/*        </option>*/}
                                        {/*    ))}*/}
                                        {/*</select>}*/}

                                        {/*{formData.resources[i].region !== "" && <select*/}
                                        {/*    value={r.size}*/}
                                        {/*    onChange={(e) => {*/}
                                        {/*        const selectedOption = e.target.options[e.target.selectedIndex];*/}
                                        {/*        this.handleUpdateResource(i, "price", selectedOption.getAttribute("data-price"))*/}
                                        {/*        this.handleUpdateResource(i, "size", e.target.value)*/}
                                        {/*        this.updateTotalResourceCost();*/}
                                        {/*    }*/}
                                        {/*    }*/}
                                        {/*    className="border p-2 rounded flex-1"*/}
                                        {/*>*/}
                                        {/*    <option value="">Select Size</option>*/}
                                        {/*    {this.getSizesForRegion(r.region, r.min_disk_size).map(size => (*/}
                                        {/*        <option key={size.slug} value={size.slug} data-price={size.price_hourly}>*/}
                                        {/*            {size.vcpus} CPU / {size.memory}MB / {size.disk} Disk / ${size.price_monthly}/mo - {size.description}*/}
                                        {/*        </option>*/}
                                        {/*    ))}*/}
                                        {/*</select>}*/}
                                    </div>)
                                })}
                                </div>
                        </div>
                    </div>
                )}

                {showEditor && (
                    <div className="mt-6 flex gap-3">
                        <button
                            onClick={this.handleSave}
                            disabled={savingPackage}
                            className="bg-blue-600 text-white px-4 py-2 rounded"
                        >
                            Save
                        </button>

                        <button
                            onClick={this.handleCancel}
                            className="bg-gray-300 px-4 py-2 rounded"
                        >
                            Cancel
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    loading: state.adminPackage.loading,
    packages: state.adminPackage.packages,
    packageResources: state.adminPackage.resources,
    configs: state.adminPackage.configs,
    snapshots: state.adminPackage.snapshots,
    providers: state.adminPackage.providers,
    regions: state.adminPackage.regions,
    sizes: state.adminPackage.sizes,
    error: state.adminPackage.error,
    users: state.adminTenant.users
});

export default connect(mapStateToProps, {
    fetchAllPackages,
    fetchAllUsers,
    fetchResourceTemplates,
    createPackage,
    updatePackage,
    deletePackage
})(PackageManager);
